<template>
  <div>
    <b-input-group>
      <template #append>
        <b-input-group-text class="button" @click="showDialog" v-if="!disabled">
          <b-icon v-if="icon" :icon="icon" />
        </b-input-group-text>
      </template>
      <b-input
        :placeholder="placeholder"
        :value="text"
        @keydown.prevent="showDialogWithValue"
        :required="required"
        :disabled="disabled"
      />
    </b-input-group>
    <b-modal :id="'searchDialog' + id" :title="title" @show="preselectItem" @ok="selectCurrentItem">
      <input
        placeholder="Suchbegriff eingeben..."
        type="search"
        class="form-control block mb-3"
        ref="projectSearchField"
      />
      <b-list-group style="height: 500px; overflow-y: auto" v-if="data && data.length > 0">
        <b-list-group-item
          href="#"
          :active="item.DbId == currentSelectedItemId"
          class="flex-column align-items-start"
          v-for="item in data"
          :key="item.DbId"
          @click="selectItem(item)"
          @dblclick.stop="selectItemAndClose(item)"
        >
          <div class="row">
            <div class="col-6 text-truncate" :title="item.text">
              {{ item.text }}
              <b-icon
                v-if="item.icon"
                :icon="item.icon"
                class="ml-2 text-muted"
                title="Der Benutzer wurde eingeladen, hat sich allerdings noch nicht angemeldet."
              />
            </div>
            <div class="col-6 text-muted text-truncate" :title="item.subtext" v-if="item.subtext">
              <small>
                <small>{{ item.subtext }}</small>
              </small>
            </div>
          </div>
        </b-list-group-item>
      </b-list-group>
      <div v-if="!data || (data && data.length == 0)" style="height: 500px;" class="text-center">
        {{ emptyMessage }}
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'AkLookupField',
  props: {
    icon: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    },
    selectedItemId: {
      type: [String, Number]
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Wählen'
    },
    emptyMessage: {
      type: String,
      default: 'Keine Datensätze verfügbar.'
    }
  },
  data() {
    return {
      currentSelectedItemId: null,
      currentSelectedItemText: '',
      id: Math.random(1000)
    };
  },
  computed: {
    theValue() {
      if (this.data && this.selectedItemId && this.data.length > 0) {
        const item = this.data.find(x => x.DbId == this.selectedItemId);
        if (item) return item.text;
        else return '';
      } else return '';
    }
  },
  methods: {
    showDialog() {
      this.$bvModal.show('searchDialog' + this.id);
    },
    showDialogWithValue() {
      this.$bvModal.show('searchDialog' + this.id);
    },
    selectItem(item) {
      //this.$emit('update:selectedItemId', item.id);
      this.currentSelectedItemId = item.DbId;
      this.currentSelectedItemText = item.text;
    },
    selectCurrentItem() {
      this.$emit('update:selectedItemId', this.currentSelectedItemId);
      this.$emit('update:text', this.currentSelectedItemText);
    },
    selectItemAndClose() {
      this.selectCurrentItem();
      this.$emit('change', this.currentSelectedItemId);
      this.$bvModal.hide('searchDialog' + this.id);
    },
    preselectItem() {
      if (this.currentSelectedItemId) {
        this.currentSelectedItemId = this.selectedItemId;
        const itemToPreselect = this.data.find(x => x.DbId == this.selectedItemId);
        if (itemToPreselect) this.currentSelectedItemText = itemToPreselect.text;
      } else if (this.selectedItemId) {
        this.currentSelectedItemId = this.selectedItemId;
        const itemToPreselect = this.data.find(x => x.DbId == this.selectedItemId);
        if (itemToPreselect) this.currentSelectedItemText = itemToPreselect.text;
        //this.currentSelectedItemText = this.data.find(x => x.DbId == this.selectedItemId).text;
      } else {
        this.currentSelectedItemText = '';
        this.currentSelectedItemId = null;
      }
    }
  }
};
</script>

<style>
.button {
  cursor: pointer;
}
</style>
